jQuery(document).ready(function ($) {
  const body = $('body');
  const header = $('.site-header');
  const isMobile = window.matchMedia('(min-width: 0px) and (max-width: 575px)');
  const isWideMobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)');

  $(function () {
    AOS.init({
      startEvent: 'DOMContentLoaded',
      delay: 200,
      offset: 80
    });
  });

  $(window).on('load scroll', function () {
    if ($(this).scrollTop() > 0) {
      header.addClass('site-header--scrolled');
    } else {
      header.removeClass('site-header--scrolled');
    }
  });

  // animated button
  const animatedButton = $('.site-header__contacts-link');

  function animateButton() {
    const icons = animatedButton.find('.site-header__contacts-link-icon');
    const activeIcon = animatedButton.find('.site-header__contacts-link-icon--active');
    const nextIcon = activeIcon.next('.site-header__contacts-link-icon').length
      ? activeIcon.next('.site-header__contacts-link-icon')
      : icons.first();

    activeIcon.removeClass('site-header__contacts-link-icon--active').addClass('site-header__contacts-link-icon--moved');
    nextIcon.addClass('site-header__contacts-link-icon--active');

    setTimeout(function () {
      activeIcon.removeClass('site-header__contacts-link-icon--moved');
    }, 1000);
  }

  if (animatedButton.length) {
    setInterval(animateButton, 4000);
  }

  animatedButton.on('click', function (e) {
    e.preventDefault();
    const links = $('.site-header__links');

    if (links.is(':visible')) {
      $(this).removeClass('site-header__contacts-link--opened');
      links.removeClass('site-header__links--opened').fadeOut(200);
    } else {
      links.css('display', 'flex').hide()
      $(this).addClass('site-header__contacts-link--opened');
      links.fadeIn(200).addClass('site-header__links--opened');
    }
  });

  body.on('click', function (e) {
    const popover = $('.site-header__links:visible');
    const btn = animatedButton;
    if (popover.length && !popover.is(e.target) && popover.has(e.target).length === 0
      && btn.length && !btn.is(e.target) && btn.has(e.target).length === 0 && isMobile.matches ) {
      animatedButton.removeClass('site-header__contacts-link--opened');
      popover.removeClass('site-header__links--opened').fadeOut(200);
    }
  });

  body.on('click', '.site-header__contacts-link-icon', function () {
    const popover = $('.site-header__links:visible');
    popover.removeClass('site-header__links--opened').fadeOut(200);
  });
  // ~ animated button

  // menu
  const mobileMenu = $('.mobile-menu');

  body.on('click', '.js-scrollTo', function (e) {
    e.preventDefault();

    const target = $(this).data('target');
    const element = $(`#${target}`);
    const paddingTop = parseInt(element.css('padding-top'), 10);
    const offset = element.offset().top - (header.outerHeight() + (paddingTop > 0 ? 0 : 40));

    if (mobileMenu.is(':visible')) {
      mobileMenu.fadeOut(200);
    }

    $('html, body').animate({
      scrollTop: offset
    }, 500);
  });

  body.on('click', '.site-header__menu-link', function (e) {
    e.preventDefault();
    mobileMenu.fadeIn(200);
  });

  body.on('click', '.js-closeMenu', function (e) {
    e.preventDefault();
    mobileMenu.fadeOut(200);
  });
  // ~ menu

  // phone mask
  $('.js-phoneInput').mask('+7 (000) 000-00-00', {placeholder: "+7"});
  // ~ phone mask

  // request
  setTimeout(function() {
    $("[name=validation]").val('');
  }, 1000);

  $('.input').on('focus', function () {
    $(this).removeClass('input--error');
  });

  function checkFields(fields, ok) {
    fields.each(function () {
      const input = $(this);

      if (!input.val().length) {
        ok = false;

        input.addClass('input--error');
      }
    });

    return ok;
  }
  let formSubmitted = false;

  body.on('submit', '[data-ajax-form]', function (e) {
    e.preventDefault();
    const form = $(this);
    const formData = new FormData(this);
    const modal = $('.request-modal');
    let ok = true;

    ok = checkFields(form.find('.required'), ok);

    if (ok === true && formSubmitted === false) {
      formSubmitted = true;

      $.ajax({
        type: "POST",
        url: '/wp-admin/admin-ajax.php?action=request',
        processData: false,
        contentType: false,
        data: formData,
        success: function () {
          formSubmitted = false;
          if (modal.is(':visible')) {
            modal.find('.request__content').hide();
            modal.find('.request__success').show();
          } else {
            alertify.success('Спасибо! Мы свяжемся с вами в ближайшее время');
          }
          form.trigger('reset');
        },
        error: function () {
          formSubmitted = false;
          alertify.error('Упс. Что-то пошло не так');
        },
      });
    }
  });
  // ~ request

  // modals
  function openModal(modal) {
    const scrSize = window.innerWidth;
    const scrAvail = body.innerWidth();
    const padRight = scrSize - scrAvail;

    body.css({
      'overflow': 'hidden',
      'padding-right': `${padRight}px`,
    });

    $(modal).fadeIn(300);
  }

  function closeModal(modal) {
    modal.fadeOut(300);

    setTimeout(function(){
      body.css({
        'overflow': 'visible',
        'padding-right': 0
      });
    }, 400);
  }

  body.on('click', function (e) {
    const modal = $('.custom-modal').last();
    const modalDialog = modal.find('.custom-modal__dialog');

    if (modal.is(e.target) || modalDialog.is(e.target)) {
      closeModal(modal);
    }
  });

  body.on('click','.js-closeModal', function (e) {
    e.preventDefault();

    closeModal($(this).parents('.custom-modal'));
  });

  body.on('keydown', function (e) {
    const modal = $('.custom-modal').last();

    if (e.code === 'Escape' && modal.is(':visible')) {
      closeModal(modal);
    }
  });

  body.on('click', '.js-openRequestModal', function (e) {
    e.preventDefault();
    const modal = $('.request-modal');
    openModal(modal);

    modal.find('.request__content').show();
    modal.find('.request__success').hide();
  });
  // ~ modals

  // map
  const map = $('#map');
  let mapTimeout = null;
  if (map.length) {
    let placemarks = [];

    $.ajax({
      type: "GET",
      url: '/wp-admin/admin-ajax.php?action=marks',
      success: function (response) {
        placemarks = JSON.parse(response);

        ymaps.ready(initContactsMap);
      },
    });

    function initContactsMap() {
      const collection = new ymaps.GeoObjectCollection(null, {
        preset: 'islands#yellowIcon'
      });
      const myMap = new ymaps.Map('map', {
        center: [57.1404992, 65.5548429],
        zoom: 12,
        controls: ['zoomControl'],
        autoFitToViewport: 'always',
      }, {
        zoomControlFloat: 'none',
        zoomControlPosition: {
          right: 10,
          top: 10
        },
        zoomControlSize: 'small',
        suppressMapOpenBlock: true
      });

      const defaultOptions = {
        iconImageHref: '/wp-content/themes/kp-franchise/assets/img/map-mark.svg',
      };
      const activeOptions = {
        iconImageHref: '/wp-content/themes/kp-franchise/assets/img/active-map-mark.svg',
      };

      placemarks.map((item) => {
        const coordinates = item.coordinates.split(', ');
        const placemark = new ymaps.Placemark([Number(coordinates[0]), Number(coordinates[1])], {
          defaultOptions,
          activeOptions,
          id: item.post_id,
        }, {
          iconLayout: 'default#image',
          iconImageHref: '/wp-content/themes/kp-franchise/assets/img/map-mark.svg',
          iconImageSize: [30, 47],
          iconImageOffset: [-15, -47],
        });
        collection.add(placemark)
      });

      collection.get(0).options.set(collection.get(0).properties.get('activeOptions'));

      collection.events.add('click', function (e) {
        const activeGeoObject = e.get('target');
        const tile = $('.map__tile');
        activeGeoObject.options.set(activeGeoObject.properties.get('activeOptions'));

        tile.addClass('map-tile--loading');
        $.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php?action=fetch_post',
          data: {
            id: activeGeoObject.properties.get('id'),
          },
          success: function (response) {
            const block = $('.map');

            const button = $('.map-tile__button');
            const content = $('.js-fetchedContent');
            content.html(response);

            button.removeClass('map-tile__button--closed')
            tile.removeClass('map__tile--hidden');
            block.removeClass('map--full-width');
            tile.removeClass('map-tile--loading');
            myMap.container.fitToViewport();

            if (isWideMobile.matches) {
              const element = $('.map-tile');
              const offset = element.offset().top - header.outerHeight();

              $('html, body').animate({
                scrollTop: offset
              }, 500);
            }
          },
        });

        collection.each(function (geoObject) {
          if (geoObject !== activeGeoObject) {
            geoObject.options.set(geoObject.properties.get('defaultOptions'));
          }
        })
      })

      myMap.behaviors.disable(['scrollZoom']);
      myMap.geoObjects.add(collection);
      myMap.setBounds(collection.getBounds()) ;

      body.on('click', '.js-toggleTile', function () {
        const block = $('.map');
        const tile = $('.map__tile');

        $(this).toggleClass('map-tile__button--closed')
        tile.toggleClass('map__tile--hidden');
        block.toggleClass('map--full-width');

        myMap.container.fitToViewport();
      });

      $(window).on('load resize orientationchange', function () {
        clearTimeout(mapTimeout);
        mapTimeout = setTimeout(function () {
          mapTimeout = null;
          myMap.setBounds(collection.getBounds()) ;
        }, 200);
      });
    }
  }
  // ~ map
});
